import { computed } from 'vue';
import { useStore } from 'vuex';

export function useWarDates(): { startDate: string, endDate: string } {
  const store = useStore();
  const warDate = computed(() => store.state.war);

  const startDate = computed(() => {
    switch (warDate.value) {
      case 'suez-crisis':
        return '1956-10-27';
      default:
        return '1948-05-11';
    }
  });

  const endDate = computed(() => {
    switch (warDate.value) {
      case 'suez-crisis':
        return '1956-11-07';
      default:
        return '1949-07-20';
    }
  });

  return {
    startDate: startDate.value,
    endDate: endDate.value
  };
}
